export const APP_BASE_URL = '';

export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SUCCESS: 'success',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
};

// Chat 3.0 (AE): prefixo renomeado. Aceita o antigo para compatibilidade.
export const WOOT_PREFIX = 'fluxo-widget:';
export const WOOT_PREFIX_OLD = 'chatwoot-widget:';
